<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<button type="button" class="btn btn-danger btn-ico" [ngbTooltip]="'DELETE_BUTTON.DELETE' | translate" container="body">
  <i class="fal fa-trash"></i>
</button>
